import React, { useEffect } from "react";
import { Container, Row, Col, Image, Navbar, Nav } from "react-bootstrap";
import aboutImg from "../Images/home.jpg";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function Aboutus() {

    // ⭐ Scroll Animation Effect
    useEffect(() => {
        const elements = document.querySelectorAll(".fade-up, .slide-in-left");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("animate");
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <div>
            {/* Navbar */}
            <Header />

            {/* About Section */}
            <section className="about-section py-5 bg-light">
                <Container>
                    <Row className="align-items-center">
                        {/* Left: Image */}
                        <Col md={6} className="mb-4 mb-md-0 fade-up">
                            <Image
                                src={aboutImg}
                                alt="About Akul Creation"
                                fluid
                                rounded
                                className="shadow-sm slide-in-left"
                            />
                        </Col>

                        {/* Right: Text */}
                        <Col md={6} className="fade-up delay-1">
                            <h2 className="fw-bold text-danger mb-3">About Akul Creations</h2>
                            <p className="text-muted">
                                At <strong>Akul Creations</strong>, we believe that fashion is more
                                than just clothing — it’s an expression of individuality and
                                culture. With years of experience in tailoring and design, our
                                team crafts elegant and customized outfits that celebrate your
                                personality and style.
                            </p>
                            <p className="text-muted">
                                From traditional saree blouses to modern designer wear, each
                                creation is carefully designed to bring out the best in you. We
                                blend creativity, comfort, and craftsmanship to deliver
                                exceptional quality garments for every occasion.
                            </p>
                            <p className="fw-bold text-dark">
                                ✂️ Tailored with passion. Designed for you.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Footer */}
            <Footer />
        </div>
    );
}
